import React from 'react';
import CuponesForm from './CuponesForm';

const NuevoCupon = () => {
    return <CuponesForm mode="NUEVO" />;
};

export default NuevoCupon;
